module.exports = __webpack_public_path__ + "static/media/digitales-03.331cff5c.png";